export default __webpack_public_path__ + "static/media/logo_mtsz.d51f70f2.png";